import * as angular from "angular";
import {IController} from "angular";

export class packageSizeIconCtrl implements IController {

  id: string;
  icon: string;
  name: string;
  packingDisplayStatus: string;
  isMissingPackage: boolean;

  private sitePackageItemsMap: any;

  /* @ngInject */
  constructor(private splitService) {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
  }

  $onInit() {
    this.icon = this.id ? this.sitePackageItemsMap[this.id].icon : this.icon;
    this.name = this.id ? this.sitePackageItemsMap[this.id].name : this.name;
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.id && !changes.id.isFirstChange()) {
      this.$onInit();
    }
  }


}

angular
  .module('bringoz.admin.commons')
  .component('bringozPackageItemIcon', {
    bindings: {
      id: '<?',
      icon: '<?',
      name: '<?',
      isMissingPackage: '<?',
      packingDisplayStatus: '<?'
    },
    template: require('./bringoz-package-item-icon.html').default,
    controller: packageSizeIconCtrl
  });
